import axios from 'axios';

export interface IHeaderInformation {
  auth: string;
  apptype: string;
}

export const getLink = async (params: IHeaderInformation) => {
  const { auth, apptype } = params;
  const response = await axios.get(
    `${process.env.REACT_APP_BFF_URL}/web/v1/underwriting/link/?appType=${apptype}`,
    {
      headers: {
        'authorization-info': `${auth}`,
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};
